import { useEffect, useState } from "react";

import { useAuthState } from "react-firebase-hooks/auth";
import { auth, db } from "../../../util/firebase";
import { query, collection, getDocs } from "firebase/firestore";

import { useNavigate, useParams } from "react-router-dom";

// import classnames from 'classnames';

import BarLoader from "react-spinners/BarLoader";

import { FaChevronLeft } from "react-icons/fa";

import { useTranslation } from "react-i18next";

function AchievementsPage() {
  const { t } = useTranslation("common");

  const params = useParams();
  const friendUid = params.friendUid;

  // eslint-disable-next-line
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();

  const [user] = useAuthState(auth);

  // eslint-disable-next-line
  const [achievements, setAchievements] = useState();
  // eslint-disable-next-line
  const [achievementsUnlocked, setAchievementsUnlocked] = useState();
  const fetchAchievements = async () => {
    try {
      setIsLoading(true);

      let fetchedAchievements = [];
      let fetchedAchievementsUnlocked = 0;

      const q = query(collection(db, "achievements"));
      const docs = await getDocs(q);
      docs.forEach((doc) => {
        const newAchievement = doc.data();
        if (newAchievement.isActive) {
          if (
            newAchievement.achieverUids.includes(
              friendUid ? friendUid : user.uid
            )
          ) {
            fetchedAchievementsUnlocked += 1;
          }
          fetchedAchievements.push(newAchievement);
        }
      });

      setAchievements(fetchedAchievements);
      setAchievementsUnlocked(fetchedAchievementsUnlocked);

      setIsLoading(false);
    } catch (err) {
      console.error(err);
      alert("An error occured while fetching achievements");
    }
  };

  useEffect(() => {
    fetchAchievements();
    // eslint-disable-next-line
  }, []);

  if (isLoading)
    return (
      <div className="loadingPage">
        <img
          alt="logo"
          src="https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Flogos%2F01%20-%20SL%20Logo%203.png?alt=media&token=2e5a6320-d2d7-45f8-9bc9-a8f9c7f8caa6"
          style={{
            width: 100,
            marginBottom: "1rem",
          }}
        />
        <BarLoader color="#005EE1" />
      </div>
    );

  return (
    <div id="achievementsPage" className="page">
      <h1>
        <FaChevronLeft
          onClick={() => navigate(-1)}
          style={{
            color: "#005EE1",
            width: 35,
            height: 35,
            marginTop: -8,
            marginRight: "0.25rem",
            cursor: "pointer",
          }}
        />
        {t("achievements").toUpperCase()}
        {/* <span>
          {achievementsUnlocked}
        </span> */}
      </h1>
      <div>
        <p style={{ color: "#FFFFFF", textAlign: "center", marginTop: "2rem" }}>
          {t("comingSoon")}
        </p>
        {/* {
          achievements?.length === 0 &&
            <p style={{color: '#FFFFFF', textAlign: 'center', marginTop: '2rem'}}>
              {t('thereAreNoAchievementsYet')}
            </p>
        }
        {
          // eslint-disable-next-line
          achievements?.map(achievement => {
            if (achievement.achieverUids.includes(user.uid)){
            return (
              <div className={classnames(
                'achievementContainer',
                {
                  locked: !achievement.achieverUids.includes(user.uid)
                }
              )}>
                <img
                  alt="achievementImage"
                  src={achievement.image}
                />
                <div>
                  <p className='achievementName'>
                    {achievement.name.toUpperCase()}
                  </p>
                  <p className='achievementDescription'>
                    {achievement.description}
                  </p>
                </div>
              </div>
            )
            }
          })
        }
        {
          // eslint-disable-next-line
          achievements?.map(achievement => {
            if (!achievement.achieverUids.includes(user.uid)){
            return (
              <div className={classnames(
                'achievementContainer',
                {
                  locked: !achievement.achieverUids.includes(user.uid)
                }
              )}>
                <img
                  alt="achievementImage"
                  src="https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Favatars%2FdefaultAvatar.png?alt=media&token=4fe7a7cf-b2a3-42bf-9d0a-067cb0fcfd72"
                />
                <div>
                  <p className='achievementName'>
                    {achievement.name.toUpperCase()}
                  </p>
                  <p className='achievementDescription'>
                    {achievement.description}
                  </p>
                </div>
              </div>
            )
            }
          })
        } */}
      </div>
    </div>
  );
}

export default AchievementsPage;
